import { createContext, useContext } from 'react';

export const ThemeContext = createContext({
    isDark: false,
    toggleTheme: () => {}
});

export const useThemeContext = () => useContext(ThemeContext);
